import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { loadReCaptcha, RecaptchaService } from 'lib-shared';
import { CommonModule } from '@angular/common';
declare var grecaptcha: any;
@Component({
  selector: 'app-test-recaptcha',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './test-recaptcha.component.html',
  styleUrls: ['./test-recaptcha.component.scss']
})
export class TestRecaptchaComponent {
  recaptchaForm: FormGroup;
  jsonData: any;

  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.recaptchaForm = this.fb.group({
      token: ['', Validators.required],
      websiteKey: ['', Validators.required],
      privateKey: ['', Validators.required]
    });
  }

  async generateToken() {
    const websiteKey = this.recaptchaForm.get('websiteKey').value;
    this.recaptchaForm.patchValue({ token: '' });

    try {
      await loadReCaptcha(websiteKey);
    } catch (e) {
      console.error('Error cargando el script de reCAPTCHA:', e);
      alert('No se pudo cargar el script de reCAPTCHA.');
      return;
    }

    if (!window['grecaptcha'] || !window['grecaptcha'].enterprise) {
      console.error('reCAPTCHA no está cargado');
      alert('reCAPTCHA no está cargado');
      return;
    }

    try {
      await window['grecaptcha'].enterprise.ready(async () => {
        try {
          const token = await window['grecaptcha'].enterprise.execute(websiteKey, { action: 'testAction' });
          this.recaptchaForm.patchValue({ token: token });
        } catch (error) {
          console.error('Error ejecutando reCAPTCHA:', error);
          alert('Error ejecutando reCAPTCHA');
        }
      });
    } catch (error) {
      console.error('Error en ready de reCAPTCHA:', error);
      alert('Error en ready de reCAPTCHA');
    }
  }

  onSubmit() {
    if (this.recaptchaForm.valid) {
      const formData = this.recaptchaForm.value;

      this.http.post('https://hub-sta.011global.com/api/Testing/recaptcha-fraud-detection', formData)
        .subscribe({
          next: (response) => {
            this.jsonData = response;
          },
          error: (error) => {
            console.error('Error:', error);
            alert('An error occurred while submitting the form.');
          }
        });
    } else {
      alert('Please fill out all required fields.');
    }
  }
}